import { locale } from '@portal/locale';

/** Load localization strings */
export const useLocale = () => {
  return { locale };
};
